import React from 'react'
import abImg from '../../images/113.jpg'
import abImg2 from "../../images/about_4.jpg";


const About = (props) => {

    return (
      <section className="about-section separator-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="about-img-wrap">
                <div className="about-img-top">
                  <img src={abImg} alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-text">
                <h2>Our Mission</h2>
                <p>
                  At Chemist For All, our mission is simple: to provide our
                  customers with safe and affordable healthcare. We provide
                  generic medicines that are just as effective as brand-name
                  drugs, at a fraction of the cost.
                </p>
                <p>
                  We work with certified and well-established pharmaceutical
                  manufacturers in India, ensuring every medicine we offer meets
                  high standards of quality and safety. All products are
                  thoroughly checked before being processed for shipping.
                </p>
                <p>
                Whether you need daily prescription medications or over-the-counter medications, our goal is to help you access what you need, conveniently, securely, and at affordable prices.
                </p>
                <p>
                Our chemist home delivery model ensures that you receive medicines at your doorstep, no matter where you are in the USA, UK, or Australia.
                </p>
                {/* <div className="row">
                  <div className="col-sm-6">
                    <div className="about-features">
                      <i className="icon-medical"></i>
                      <h3>Doctors</h3>
                      <p>
                        I have been a loyal customer of this auto parts company
                        for years .
                      </p>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="about-features">
                      <i className="icon-medicine"></i>
                      <h3>Equipment's</h3>
                      <p>
                        I have been a loyal customer of this auto parts company
                        for years .
                      </p>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
} 

export default About;